module.exports = __webpack_public_path__ + "img/undraw_collecting_fjjl.b557b496.svg";